import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { EntryReceiptMovement } from '../../models/Entry';
import { ReceiptApiAdapter } from '../adapters/ReceiptApiAdapter';

export const useMovements = (
    entryId: number,
    receiptId: number,
    enabled: boolean = true,
    locationId?: number
) => {
    const httpClient = createHttpClient(apiClientWH);
    const receiptAdapter = new ReceiptApiAdapter(httpClient);

    return useQuery<EntryReceiptMovement[], Error>({
        queryKey: ['entry-receipt-movements', entryId, receiptId, locationId],
        queryFn: () => receiptAdapter.getMovements(entryId, receiptId, locationId ? { location_id: locationId } : undefined),
        enabled: entryId > 0 && receiptId > 0 && enabled,
        staleTime: 10 * 1000, // 10 segundos
    });
};

